export const logout = payload => ({
  type: 'LOGOUT',
  payload,
  loader: true,
});

export const clearStore = data => ({
  type: 'CLEARALL',
  data,
});
